import { API_PREFIX } from "./constant";
import { Request } from "./request";

export interface AnswerParams {
    id?: number
    digest?: string
    url?: string
}

//新增答案
export function createAnswer(params: AnswerParams): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/insertOrUpdateAnswer`,
        method: "POST",
        body: params
    }
}

interface QuestionParams {
    id?: number
    questions?: string
    label?: string
    answerId?: string
}

// 新增问题
export function createQueation(params: QuestionParams): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/insertOrUpdateQuestion`,
        method: "POST",
        body: params
    }
}

//上传图片
export function updateFile(params: any): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/updateFile`,
        method: "POST",
        body: params
    }
}

//答案列表
export function searchAnswerList(params: { str: string, current: number, size: number }): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/searchAnswerList`,
        method: "GET",
        params
    }
}

//列表
export function getQaList(params: { current: number, size: number }): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/getQaList`,
        method: "GET",
        params
    }
}

//展开
export function getAnswerList(params: { ids: any }): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/getAnswerList`,
        method: "GET",
        params
    }
}

//新增问题
export function insertOrUpdateQuestion(params: any): Request {
    return {
        url: `${API_PREFIX}/blade-administer/m/qa/insertOrUpdateQuestion`,
        method: "POST",
        body: params
    }
}